import { useEffect } from "react";

export default function useOrganizationJsonLd() {
  useEffect(() => {
    const id = "org-jsonld";
    if (document.getElementById(id)) return;

    const data = {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Pdf-Convert",
      url: "https://pdf-convert.fr",
      logo: "https://pdf-convert.fr/favicon.ico",
      contactPoint: {
        "@type": "ContactPoint",
        contactType: "customer support",
        availableLanguage: "French",
      },
      sameAs: [],
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.text = JSON.stringify(data);
    document.head.appendChild(script);
  }, []);
}
